 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		32: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		32: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"vendors~components-Champions~components-Leaderboards-LeaderboardsPage~components-StatsTables-Combat~~cb0e57cc","1":"components-Champions~components-Items-Items~components-StatsTables","2":"components-Champions~components-SummonerProfiles-views-LiveGame-LiveGameMain~components-SummonerProf~2f8e532f","3":"components-SummonerProfiles-views-LiveGame-LiveGameMain","4":"vendors~components-Accounts-Settings-Settings~components-Premium-views-PremiumCheckout","5":"components-Accounts-PasswordReset-PasswordReset","6":"components-Accounts-RecoverAccount-RecoverAccount","7":"components-Accounts-Settings-Settings","8":"components-Careers","9":"components-Champions","10":"components-Champions-ItemsTable-ItemsTableContainer","11":"components-Champions-Overview","12":"components-Champions-RunesGuide-RunesGuideContainer","13":"components-DesktopAppSplashPage-DesktopAppSplashPage","14":"components-Items-Items","15":"components-Leaderboards-LeaderboardsPage","16":"components-Pages-About-About","17":"components-Pages-EmailVerificationPage-EmailVerificationPage","18":"components-Pages-FAQ","19":"components-Pages-LandingPage-LandingPageContainer","20":"components-Pages-SupportUs-SupportUsPage","21":"components-Premium-views-PremiumCheckout","22":"components-PrivacyPolicy","23":"components-PrivacyShield","24":"components-StatsTables","25":"components-StatsTables-Combat","26":"components-StatsTables-DuoTierList","27":"components-StatsTables-Objectives","28":"components-StatsTables-TierList","29":"components-SummonerProfiles-views-LiveGame-LiveGameSplash","30":"components-SummonerProfiles-views-ProfilesMain-SummonerProfile","31":"components-TermsOfService","33":"vendors~components-Champions","34":"vendors~components-Pages-About-About","35":"vendors~components-SummonerProfiles-views-LiveGame-LiveGameSplash"}[chunkId]||chunkId) + "." + {"0":"d66b35ec658c03e96038","1":"8ddd2d27f37e851268f4","2":"2d8c9903aadb73df7733","3":"f7b615ba8bdb0ea9edfe","4":"482126b22dd38978858b","5":"344de61312c3c7b68396","6":"063d1856c53a8c6214cc","7":"26ab38190b9664a5530c","8":"86c2977ae37179426ab8","9":"259bcbb27d8779a5b6ce","10":"fab0e99e776853925495","11":"efa826852677ddbb8ffd","12":"d16f358d7ce787f6c1bf","13":"d36b146ef51261217c81","14":"89a106e46c4e95148db1","15":"0d6f5b2b55ab88298af5","16":"1879dbc273062ee59b03","17":"551660858d820b7d6337","18":"fa8cf42a61534573422b","19":"a52434fd1a496979fac7","20":"95145a18f07026d4bac5","21":"c819c1ab25e8f3be1749","22":"0441be07d690aa60b02c","23":"5c618be5767a0c58a9e7","24":"b58f3984c968156223e5","25":"ab36bcdfa4602091da01","26":"ba0203ea02e8421da1ec","27":"f8c0f0603f042d3b092c","28":"a1c7f2290623b88b9c91","29":"2f898bf1f051bda1cf06","30":"715d3bccf502380800d0","31":"6a9afce6b03fdec8dba9","33":"225d4c8c2f3d64bfd6c1","34":"ccf4563a66ad3f369edf","35":"073e71a41de840d0a1db","37":"15d2e6762100b9a1ef30","38":"b051c54d1efb595d1c20","39":"7e204cf6de017b517e93","40":"79ef055d0af209f78c79","41":"111f9d5ff7f617356baf","42":"fffd655d502e640c8a89","43":"417a0f53d58aec007d35","44":"b7b683d0760b25d2ccb0","45":"d2640bccb93f43ce382b","46":"af6762ea371bd618d38a","47":"3884ab8399e484828c8c","48":"7c18f849a58f947068a2","49":"7e7b28caf7372d4e3ec5","50":"8d74a224086fc7082e99","51":"bf2057f80765851d2001","52":"9e221f87b0acb27f6843","53":"5e26d2607858ccf0ed79","54":"893c8329e0a3dcae99e4","55":"3df82e6766960c90bf03","56":"9f2dfc5c024089ab0093","57":"9540610343756f3a15e9","58":"c9d3a480c01fea1324f7","59":"bc6d38f4d357080f77c5","60":"175a085b0cac4a1ec52f","61":"a6475cf497b6f1241e91","62":"aea042c95d8f9251fcc7","63":"076e083cb74164bdacfc","64":"317cb116d8897b4d65bf","65":"f49f2c7c6d86b3aa2880","66":"502924bee97837820e44","67":"b7354f3a3a878ffa7d6e","68":"1ac2ef60646d6addf58c","69":"26cd88397ac60d263f64","70":"58e20cbac59dc3b45022","71":"a445d8846c370edce7dd","72":"e96197e087a6f56e2a36","73":"3f66992dd6c6cbec83e2","74":"7ca5d5c302aca2ea5619","75":"fec97bd5acce0fca9ee1","76":"06f60a9d6c93abc7c418","77":"727ab6ac0a355f2bd097","78":"5fab942f6e6b82b5af41","79":"368d55a1666918451907","80":"81e2e0fbfbf090bab8c2","81":"619fedbcdcd546a46405","82":"b3ffdce632ad381c1c01","83":"9bce703bc9d1f04a43d2","84":"7f3d4b996b96c64b52d5","85":"775e8fa023459c77d0b1","86":"294b47292b97f6e94c04","87":"8f6d02bc5aba624a1993","88":"c22b98fa5e93ed93739b","89":"0d0a6fee5d9efe96b254","90":"8e1bb30d7b801abca459","91":"aa5bd442c78df187fb65","92":"37185aedc63930e27750","93":"a8fabb0313746f1ca163","94":"b892ff397382353b634d","95":"271af89f69f1f193d715","96":"db1a9bf73717522b4bfd","97":"9bc9d08e73f7aba109ef","98":"a38ac9910b2aad64599e","99":"5436c4829e10f63b5888","100":"21e9d6834986b6ee921b","101":"b4d8ae26f927bb9fff07","102":"d31b485e9ddae33e6b5a","103":"4b93ce8339e57c2e6fd3","104":"11326254cb6901d7456d","105":"45b4e43b1ac64b7d90ce","106":"7e74d848f688b1440885","107":"64340259581231cfd4ee","108":"4fe510b2dc72c03578b1","109":"c16e9753eb1115e93e0d","110":"0f950361b7f5845edb7e","111":"e1706b883bfcd2d91808","112":"ac9824341f39efe9bcff","113":"68f153854267db6f6098","114":"e1b19c567fdbbf1e5615","115":"383d1ebe2b084deea713","116":"f8ec8ee5c6ae0cfc6e65","117":"600f59fb6a5f0412906a","118":"5be51d2ed454d852afb8","119":"0d0edfc90b366626cfe6","120":"d49819b57973e68f1564","121":"110e955031397ce98ee1","122":"6f26ca2684f3b11ea0e8","123":"4abb27076f5f1a911c09","124":"3fa06a34d20ae4c7db86","125":"8231bb8d4010272c3681","126":"854613bfc7e32750d9b8","127":"71fd7da8d421820447fe","128":"f4d8f54ad492e1c52277"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"34":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"0":"vendors~components-Champions~components-Leaderboards-LeaderboardsPage~components-StatsTables-Combat~~cb0e57cc","1":"components-Champions~components-Items-Items~components-StatsTables","2":"components-Champions~components-SummonerProfiles-views-LiveGame-LiveGameMain~components-SummonerProf~2f8e532f","3":"components-SummonerProfiles-views-LiveGame-LiveGameMain","4":"vendors~components-Accounts-Settings-Settings~components-Premium-views-PremiumCheckout","5":"components-Accounts-PasswordReset-PasswordReset","6":"components-Accounts-RecoverAccount-RecoverAccount","7":"components-Accounts-Settings-Settings","8":"components-Careers","9":"components-Champions","10":"components-Champions-ItemsTable-ItemsTableContainer","11":"components-Champions-Overview","12":"components-Champions-RunesGuide-RunesGuideContainer","13":"components-DesktopAppSplashPage-DesktopAppSplashPage","14":"components-Items-Items","15":"components-Leaderboards-LeaderboardsPage","16":"components-Pages-About-About","17":"components-Pages-EmailVerificationPage-EmailVerificationPage","18":"components-Pages-FAQ","19":"components-Pages-LandingPage-LandingPageContainer","20":"components-Pages-SupportUs-SupportUsPage","21":"components-Premium-views-PremiumCheckout","22":"components-PrivacyPolicy","23":"components-PrivacyShield","24":"components-StatsTables","25":"components-StatsTables-Combat","26":"components-StatsTables-DuoTierList","27":"components-StatsTables-Objectives","28":"components-StatsTables-TierList","29":"components-SummonerProfiles-views-LiveGame-LiveGameSplash","30":"components-SummonerProfiles-views-ProfilesMain-SummonerProfile","31":"components-TermsOfService","33":"vendors~components-Champions","34":"vendors~components-Pages-About-About","35":"vendors~components-SummonerProfiles-views-LiveGame-LiveGameSplash"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"c84267a7d3b7edd22693","35":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c","88":"31d6cfe0d16ae931b73c","89":"31d6cfe0d16ae931b73c","90":"31d6cfe0d16ae931b73c","91":"31d6cfe0d16ae931b73c","92":"31d6cfe0d16ae931b73c","93":"31d6cfe0d16ae931b73c","94":"31d6cfe0d16ae931b73c","95":"31d6cfe0d16ae931b73c","96":"31d6cfe0d16ae931b73c","97":"31d6cfe0d16ae931b73c","98":"31d6cfe0d16ae931b73c","99":"31d6cfe0d16ae931b73c","100":"31d6cfe0d16ae931b73c","101":"31d6cfe0d16ae931b73c","102":"31d6cfe0d16ae931b73c","103":"31d6cfe0d16ae931b73c","104":"31d6cfe0d16ae931b73c","105":"31d6cfe0d16ae931b73c","106":"31d6cfe0d16ae931b73c","107":"31d6cfe0d16ae931b73c","108":"31d6cfe0d16ae931b73c","109":"31d6cfe0d16ae931b73c","110":"31d6cfe0d16ae931b73c","111":"31d6cfe0d16ae931b73c","112":"31d6cfe0d16ae931b73c","113":"31d6cfe0d16ae931b73c","114":"31d6cfe0d16ae931b73c","115":"31d6cfe0d16ae931b73c","116":"31d6cfe0d16ae931b73c","117":"31d6cfe0d16ae931b73c","118":"31d6cfe0d16ae931b73c","119":"31d6cfe0d16ae931b73c","120":"31d6cfe0d16ae931b73c","121":"31d6cfe0d16ae931b73c","122":"31d6cfe0d16ae931b73c","123":"31d6cfe0d16ae931b73c","124":"31d6cfe0d16ae931b73c","125":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.bigbrain.gg/lol/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1222,36]);
 	// run deferred modules when ready
 	return checkDeferredModules();
